import { forwardRef, Ref } from 'react';

import clsx from 'clsx';

import {
  ArtworkResolutions,
  imageCoreToUrl,
  addImageExtension,
} from '@/common/components/ArtworkPicture/artworkUri';
import RouterLink from '@/common/components/RouterLink/RouterLink';
import { SliderLazyImage } from '@/common/components/SliderArtworkItem/SliderLazyImage';
import { WishlistButton } from '@/common/components/WishlistButton/WishlistButton';
import { ResolutionsSrcSet } from '@/common/constants/displateRoutes';
import { RouteToProductPage } from '@/modules/ProductPage/ProductPageConfig';
import { ArtworkOrientation, GalleryItemV2 } from 'generatedBfw/static';

import styles from './sliderArtworkItem.module.scss';

export interface SliderArtworkItemProps {
  item: GalleryItemV2;
  className?: string;
  onClick?: () => void;
  onAddToWishlist?: () => void;
  onRemoveFromWishlist?: () => void;
}

export const SliderArtworkItem = forwardRef(
  (
    { item, className, onClick, onAddToWishlist, onRemoveFromWishlist }: SliderArtworkItemProps,
    ref: Ref<HTMLDivElement>,
  ) => (
    <div className={clsx(styles.container, className)} data-testid="slider-artwork-item" ref={ref}>
      <div className={styles.wishlistButtonWrapper}>
        <WishlistButton
          className={styles.wishlistButton}
          color="white"
          externalId={item.externalId}
          onAddToWishlist={onAddToWishlist}
          onRemoveFromWishlist={onRemoveFromWishlist}
        />
      </div>
      <RouterLink
        className={styles.link}
        data-testid="slider-artwork-item--link"
        href={RouteToProductPage({ externalId: item.externalId.toString() }).route}
        onClick={onClick}
      >
        <SliderLazyImage
          alt={item.title}
          className={styles[item.orientation]}
          height={item.orientation === ArtworkOrientation.HORIZONTAL ? 230 : 320}
          src={addImageExtension(
            imageCoreToUrl(
              item.imageCoreUrl,
              ArtworkResolutions.rect.rect320x230,
              item.orientation,
            ),
          )}
          srcSet={ResolutionsSrcSet({
            x1: addImageExtension(
              imageCoreToUrl(
                item.imageCoreUrl,
                ArtworkResolutions.rect.rect320x230,
                item.orientation,
              ),
            ),
            x2: addImageExtension(
              imageCoreToUrl(
                item.imageCoreUrl,
                ArtworkResolutions.rect.rect640x460,
                item.orientation,
              ),
            ),
          })}
          width={item.orientation === ArtworkOrientation.HORIZONTAL ? 320 : 230}
        />
      </RouterLink>
    </div>
  ),
);

SliderArtworkItem.displayName = 'SliderArtworkItem';
